import { FC, PropsWithChildren } from 'react'

import classnames from 'classnames'

import Icons, { IconPrefix } from '../icons'

export interface Props {
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  selected?: boolean,
  icon?: string,
  iconPrefix?: IconPrefix,
  className?: string
}

const DropdownMenuItem: FC<PropsWithChildren<Props>> = ({
  children,
  onClick,
  icon,
  className,
  selected = false,
  iconPrefix = 'far',
  ...rest
}) => {
  const classes = classnames('dropdown-item', className, { 'is-selected': selected })

  return (
    <hot-dropdown-menu-item
      slot="menu"
      class={classes}
      onClick={onClick}
      {...rest}>
      {
        icon && (
          <Icons
            iconName={icon}
            prefix={iconPrefix}
            className="dropdown-menu-item__icon" />
        )
      }
      {children}
    </hot-dropdown-menu-item>
  )
}

export default DropdownMenuItem
